import { render } from "./documentViewModal.vue?vue&type=template&id=273f61ab&scoped=true"
import script from "./documentViewModal.vue?vue&type=script&lang=js"
export * from "./documentViewModal.vue?vue&type=script&lang=js"

import "./documentViewModal.vue?vue&type=style&index=0&id=273f61ab&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273f61ab"]])

export default __exports__